import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { dbConst } from './databaseConstants';
import { KegService } from './keg.service';
import { IOnTap } from '../../models/on-tap';
import { FirestoreCrudService } from './crudService';
import { Firestore } from '@angular/fire/firestore';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class OnTapBasicService {

  private crudService: FirestoreCrudService<IOnTap>;

  constructor(
    private firestore: Firestore,
    private authService: AuthService) {
    this.crudService = new FirestoreCrudService<IOnTap>(firestore, authService, dbConst.ontapBasics);

  }

  async add(item: IOnTap) {
    const newItem = await this.crudService.add(item);
    return newItem;
  }


  async update(item: IOnTap) {
    return await this.crudService.update(item);
  }


  async delete(id: string) {
    return await this.crudService.delete(id);
  }

  getItem(id: string) {
    return this.crudService.get(id);
  }


  getItems(barId: string) {
    return this.crudService.getItemsOrderBy(barId, 'name', undefined);
  }

}
